import { ModuleConfig, TanstackQueryCraftRegistry } from "./types";

class TanstackQueryCraft {
  private modules: Record<string, ModuleConfig> = {};

  register<TModuleName extends string, TModule extends ModuleConfig>(
    moduleName: TModuleName,
    module: TModule
  ): void {
    this.modules[moduleName] = module;
  }

  get<TModuleName extends string, TKey extends string, TOptions extends any>(
    moduleName: TModuleName,
    key: TKey,
    options?: TOptions
  ): any {
    const module = this.modules[moduleName];
    if (!module) {
      throw new Error(`Module "${moduleName}" not found`);
    }

    const fn = module[key];

    if (!fn) {
      throw new Error(`Key "${key}" not found in module "${moduleName}"`);
    }

    return fn(options);
  }

  getModuleNames() {
    return Object.keys(this.modules);
  }

  getKeys<TModuleName extends keyof TanstackQueryCraftRegistry>(
    moduleName: TModuleName
  ) {
    return this.modules[moduleName];
  }
}

export const tanstackQueryCraft = new TanstackQueryCraft();
